/**
 * 값이 숫자인지 확인하는 유틸리티 함수
 * @param value - 확인할 값
 * @returns 숫자 또는 숫자 형태의 문자열이면 true
 */
export const isNumeric = (value: unknown): boolean => {
  if (typeof value === 'number') {
    return !Number.isNaN(value) && Number.isFinite(value);
  }
  if (typeof value === 'string') {
    return value.trim() !== '' && !Number.isNaN(Number(value)) && Number.isFinite(Number(value));
  }
  return false;
};
